import { AbstractControl } from '@angular/forms';
import { Base, BaseDTO } from './base.model';
import { Currency, CurrencyDTO } from './currency.model';
import { Project, ProjectDTO } from './project.model';
import { User, UserDTO } from './user.model';

export interface ProjectBonusFilters {
    user_id?: number;
    project_id?: number;
}

export interface ProjectBonusDTO extends BaseDTO {
    user_id: number;
    project_id: number;
    user: UserDTO;
    project: ProjectDTO;
    percentage: number;
}

export class ProjectBonus extends Base {

    user: User;
    project: Project;
    percentage: number;

    constructor(source: ProjectBonusDTO) {
        super(source);
        if (source) {
            if (source.user) {
                this.user = new User(source.user);
                this.addLoadedRelation('user');
            }
            if (source.project) {
                this.project = new Project(source.project);
            }
            this.percentage = source.percentage;
        }
    }

    toDTO(): ProjectBonusDTO {
        let result: ProjectBonusDTO = <ProjectBonusDTO>super.toDTO();
        result.user = this.user ? this.user.toDTO() : null;
        result.user_id = this.user ? this.user.id : null;
        result.percentage = this.percentage;
        result.project = this.project ? this.project.toDTO() : null;
        result.project_id = this.project ? this.project.id : null;

        return result;
    }

    static fromFormGroup(formGroup: AbstractControl, original?: ProjectBonus) {
        const formModel = formGroup.value;
        let projectBonus: ProjectBonus = new ProjectBonus(null);
        projectBonus.user = formModel.projectBonusUser;
        projectBonus.percentage = formModel.percentage;
        projectBonus.project = formModel.project;

        if (original) {
            projectBonus.id = original.id;
        }
        return projectBonus;
    }

}
